import { z } from 'zod';

import { emailSchema } from '@front/common/src/forms/validators/email-schema';

export const getSignInFormSchema = () =>
  z.object({
    email: emailSchema,
    password: z.string(), // does not put any validation here. Product needs
  });

export type SignInFormType = z.infer<ReturnType<typeof getSignInFormSchema>>;
